/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Knp_Terms_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_loading = /** @type {((inputs?: Knp_Terms_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载中...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み込み中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando...")
	return /** @type {LocalizedString} */ ("Loading...")
});